import { render, staticRenderFns } from "./AusPrivacyPolicyContent.vue?vue&type=template&id=36f2a2e5&scoped=true"
import script from "./AusPrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./AusPrivacyPolicyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2a2e5",
  null
  
)

export default component.exports